// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"68c83aaf","513":"0eb1794c","703":"aaf9435a"}[chunkId] + ".chunk.js";
};